/* eslint-disable @typescript-eslint/no-namespace */

import { type Brand, make } from "ts-brand";
import { type ServiceParameter } from "../configuration";
import { type PriceCalculationUnit } from "./PriceCalculationUnit";

export type PriceCalculationParameterInfo = {
    id: PriceCalculationParameterInfo.Id;
    parameterId: ServiceParameter.Id;
    combineWithParameters?: PriceCalculationParameterInfo.Id[];
    productMin?: number;
    productMax?: number;

    unit: PriceCalculationUnit;
};

export namespace PriceCalculationParameterInfo {
    export type Id = Brand<string, PriceCalculationParameterInfo>;

    export const Id = make<Id>(value => {
        if (!value || value.trim() === "") {
            throw new Error("PriceCalcuationParameterInfo: Property 'id' cannot be empty.");
        }
    });
}
